import type { SaldoDivergenteInfo } from '../types'
import { formatMoney } from '../lib/utils'

function dataHora(iso?: string | null): string | null {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  const dm = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' }).format(d)
  const hm = new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' }).format(d)
  return `${dm} ${hm}`
}

function dia(iso?: string | null): string | null {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' }).format(d)
}

/** Aviso informativo (nunca bloqueia nem ajusta): o saldo difere da Pluggy e o app aguarda o banco atualizar. */
export function AvisoSaldoDivergente({ divergencia, bancoAtualizadoEm }: { divergencia: SaldoDivergenteInfo; bancoAtualizadoEm?: string | null }) {
  const desde = dataHora(divergencia.aguardandoDesde)
  const banco = dataHora(bancoAtualizadoEm)
  const ate = dia(divergencia.reconciliaApos)
  return (
    <details className="mt-2 rounded bg-warning/10 px-2 py-1 text-2xs text-warning" data-tutorial="conta.saldo-divergente">
      <summary className="cursor-pointer list-none">
        <i className="ri-time-line" aria-hidden /> O saldo difere da Pluggy em {formatMoney(Math.abs(divergencia.diferenca))}: aguardando o banco atualizar
      </summary>
      <div className="mt-1 space-y-0.5 text-muted">
        <p>Você lançou algo depois da última atualização do banco. Quando a Pluggy atualizar, o app confere sozinho; não precisa ajustar à mão.</p>
        <p>Saldo no app: <strong className="text-white">{formatMoney(divergencia.saldoApp)}</strong></p>
        <p>Saldo na Pluggy: <strong className="text-white">{formatMoney(divergencia.saldoPluggy)}</strong></p>
        {desde && <p>Aguardando desde {desde}.</p>}
        {banco && <p>O banco atualizou em {banco}.</p>}
        {divergencia.motivo === 'carencia_dias_uteis' && ate && <p>O app ajusta sozinho a partir de {ate} se a diferença continuar.</p>}
      </div>
    </details>
  )
}
